import { throwError as observableThrowError, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServiceBase } from '@app/services/base.service';

@Injectable()
export class MeAviseService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }

  obterPorUsuario(
    pagina: number,
    somenteNaoRealizadas: boolean,
    todosFuturos: boolean,
    todosAtrasados: boolean,
    dataInicial: string,
    dataFinal: string,
    filtroUsuarioAtualId: number = 0): Observable<any> {
      let queryParams: string = `?pagina=${pagina}&somenteNaoRealizadas=${somenteNaoRealizadas}`;
      queryParams += `&todosFuturos=${todosFuturos}&todosAtrasados=${todosAtrasados}`;
      queryParams += `&dataInicial=${encodeURIComponent(dataInicial)}&dataFinal=${encodeURIComponent(dataFinal)}`;
      queryParams += `&filtroUsuarioAtualId=${filtroUsuarioAtualId}`;
      return this.http
        .get<any>(this.URL_API + `agenda/meavise/obterPorUsuario/${queryParams}`, { headers: { meta: ['search'] }});
  }

  transferirMeAvises(meAvises: any): Observable<any> {
    return this.http
      .post<any>(this.URL_API + `agenda/meavise/transferirMeAvises`, JSON.stringify(meAvises))
  }

  transferirMultiplosMeAvises(meAvises: any): Observable<any> {
    return this.http
      .post<any>(this.URL_API + `agenda/meavise/transferirMultiplosMeAvises`, JSON.stringify(meAvises));
  }

  obterMeAvise(meaviseId: any): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `home/ObterMeAvisePorId/?meaviseId=${meaviseId}`).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  ObterMeAvisePorIdComUsuarioCriacao(meaviseId: any): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `home/ObterMeAvisePorIdComUsuarioCriacao/?meaviseId=${meaviseId}`).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  realizar(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `home/RealizarMeAvise/?meaviseId=${id}`).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  transferir(id: number, usuarioDestinoId: number, data: any, prazo: any, prazoInterno: any): Observable<any> {
    const dados = {
      id: id,
      UsuarioDestinoId: usuarioDestinoId,
      Data: data,
      Prazo: prazo,
      PrazoInterno: prazoInterno
    };
    return this.http
      .post<any>(this.URL_API + `home/TransferirMeAvise`, dados).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  desativarMeAvises(meAvises: any): Observable<any>{
    return this.http
      .post<any>(this.URL_API + `agenda/meavise/desativarMeAvise`, JSON.stringify(meAvises))
  }

  obterPermissaoVisualizacaoPrazo(): Observable<boolean> {
    return this.http.get<boolean>(this.URL_API + `agenda/meavise/obterPermissaoVisualizacaoPrazo`);
  }
}
